import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Button, Container, Divider, Grid, Header, Image, Modal, Responsive } from 'semantic-ui-react';

import PlayButton from '../assets/img/play-button.svg';
import img13 from '../assets/img/slideshow/mpost54.jpg';
import img12 from '../assets/img/slideshow/mpost78.jpg';
import img14 from '../assets/img/slideshow/mpost79.jpg';

// import img1 from '../assets/img/slideshow/mpost53.jpg'
// import img2 from '../assets/img/slideshow/mpost14.jpg'
// import img3 from '../assets/img/slideshow/mpost25.jpg'
// import img4 from '../assets/img/slideshow/mpost3.jpg'
// import img5 from '../assets/img/slideshow/mpost35.jpg'
// import img6 from '../assets/img/slideshow/mpost37.jpg'
// import img7 from '../assets/img/slideshow/mpost44.jpg'
// import img8 from '../assets/img/slideshow/mpost52.jpg'
// import img9 from '../assets/img/slideshow/mpost28.jpg'
// import img10 from '../assets/img/slideshow/mpost64.jpg'
// import img11 from '../assets/img/slideshow/mpost77.jpg'
const uuidv4 = require('uuid/v4');
const featured = [
    {
        title: 'Frameblender \n Films',
        sub: 'Audsley and Tucker',
        text: 'Versatility is something you can acquire through practice, but vulnerability is a gift! This is the heart of every Frameblender Films wedding narrative. Their solid brand for emotional and immersive storytelling takes us deeper in our journey in expressing heartfelt wedding moments beyond the surface.',
        image: img12,
        video: 'https://player.vimeo.com/video/255090148',
        facebook: 'https://www.facebook.com/frameblenderfilms/',
        instagram: 'https://www.instagram.com/frameblenderfilms/',
        web: 'http://www.frameblenderfilms.com/'
    },
    {
        title: 'Tyler and Lindsey',
        sub: 'Mackenzie and Scott',
        text: 'Tyler and Lindsey’s hunger for perfection drives them to explore new things, and rediscover new strengths as they grow together in their passion for wedding cinematography. This young power couple from Texas believes their craft is not just about them doing what they love. It is – most importantly – about the couple sharing their lives.',
        image: img14,
        video: 'https://player.vimeo.com/video/244450882',
        facebook: 'https://www.facebook.com/TylerLovesLindsey/',
        instagram: 'https://www.instagram.com/tylerandlindsey',
        web: 'https://www.tylerandlindsey.com/'
    },
    {
        title: 'Mayad \n Studios',
        sub: 'Pao and Cherry',
        text: 'Our company ventured into the wedding industry 11 years ago. After eleven years, our primary aim remains the same- to deliver timeless and elegant wedding photos and films that become constant reminders of the bonds of true love and lasting commitment.',
        image: img13,
        video: 'https://player.vimeo.com/video/208095882',
        facebook: 'https://www.facebook.com/mayadstudios/',
        instagram: 'https://www.instagram.com/mayadstudios/?hl=en',
        web: 'http://www.mayadstudios.com/'
    }
]

export default class Works extends Component {
    render() {
        return (
            <div>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <Divider style={{ marginTop: 0, height: '0px', backgroundColor: 'transparent', border: 0 }} clearing />
                    <Container fluid>
                        <Grid verticalAlign="middle">
                            {Object.keys(featured).map(key => {
                                // Odd, even checker
                                if (parseInt(key) % 2 === 0) {
                                    return (
                                        <Grid.Row stretched key={uuidv4()} className="mpost-featured--row">
                                            <Grid.Column mobile={16} computer={10} largeScreen={10} className="mpost-featured-image" style={{ backgroundImage: `url(${featured[key].image})` }}>

                                                <Modal closeIcon basic dimmer="blurring" size="fullscreen" trigger={<Button size="massive" fluid inverted basic className="mpost-video--button"><Image centered src={PlayButton} /></Button>}>
                                                    <div className='embed-container'><iframe src={featured[key].video} frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
                                                </Modal>

                                            </Grid.Column>
                                            <Grid.Column mobile={16} computer={6} largeScreen={6}>

                                                <div className="mpost-featured-contents">
                                                    <Fade>
                                                        <Header as="h1" className="mpost-header--big">
                                                            {featured[key].title.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
                                                        </Header>
                                                        <Header as="h2" content={featured[key].sub} className="mpost-subheader--gradient" />
                                                        <p className="mpost-p">{featured[key].text}</p>
                                                        <p className="mpost-p">
                                                            <Button basic circular icon="facebook" href={featured[key].facebook} size="huge" className="mpost-featured--social" target="_blank" />
                                                            <Button basic circular icon="instagram" href={featured[key].instagram} size="huge" className="mpost-featured--social" target="_blank" />
                                                            <Button basic circular icon="linkify" href={featured[key].web} size="huge" className="mpost-featured--social" target="_blank" />
                                                        </p>
                                                    </Fade>
                                                </div>

                                            </Grid.Column>
                                        </Grid.Row>

                                    )
                                } else {
                                    return (
                                        <Grid.Row stretched key={uuidv4()} className="mpost-featured--row inverted">
                                            <Grid.Column mobile={16} computer={6} largeScreen={6}>
                                                <div className="mpost-featured-contents">
                                                    <Fade>
                                                        <Header as="h1" textAlign="right" style={{ color: "#FFF" }} inverted className="mpost-header--big">
                                                            {featured[key].title.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
                                                        </Header>
                                                        <Header as="h2" textAlign="right" inverted content={featured[key].sub} className="mpost-subheader--gradient" />
                                                        <p className="mpost-p inverted right">{featured[key].text}</p>
                                                        <p className="mpost-p right">
                                                            <Button basic inverted circular href={featured[key].facebook} inverted icon="facebook" size="huge" className="mpost-featured--social secondary" target="_blank" />
                                                            <Button basic inverted circular href={featured[key].instagram} inverted icon="instagram" size="huge" className="mpost-featured--social secondary" target="_blank" />
                                                            <Button basic inverted circular href={featured[key].web} inverted icon="linkify" size="huge" className="mpost-featured--social secondary" target="_blank" />
                                                        </p>
                                                    </Fade>
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column mobile={16} computer={10} largeScreen={10} className="mpost-featured-image" style={{ backgroundImage: `url(${featured[key].image})` }}>
                                                <Modal closeIcon basic dimmer="blurring" size="fullscreen" trigger={<Button size="massive" fluid inverted basic className="mpost-video--button"><Image centered src={PlayButton} /></Button>}>
                                                    <div className='embed-container'><iframe src={featured[key].video} frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
                                                </Modal>
                                            </Grid.Column>
                                        </Grid.Row>
                                    )
                                }
                            })}
                        </Grid>
                    </Container>
                    <Divider style={{ marginTop: 0, height: '0px', backgroundColor: 'transparent', border: 0 }} clearing />
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                    <div>
                        {Object.keys(featured).map(key => {
                            // Odd, even checker
                            if (parseInt(key) % 2 === 0) {
                                return (
                                    <div key={uuidv4()}>
                                        <div className="mpost-featured-image mobile" style={{ backgroundImage: `url(${featured[key].image})` }}>
                                            <Modal closeIcon basic dimmer="blurring" size="fullscreen" trigger={<Button size="massive" fluid inverted basic className="mpost-video--button mobile"><Image centered src={PlayButton} /></Button>}>
                                                <div className='embed-container'><iframe src={featured[key].video} frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
                                            </Modal>
                                        </div>
                                        <div className="mpost-featured-contents mobile">
                                            <Fade>
                                                <Header as="h1" textAlign="center" className="mpost-header--big mobile">
                                                    {featured[key].title.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
                                                </Header>
                                                <Header textAlign="center" as="h3" content={featured[key].sub} className="mpost-subheader--gradient" />
                                                <p className="mpost-p mobile">{featured[key].text}</p>
                                                <p className="mpost-p mobile" style={{textAlign:'center'}}>
                                                    <Button basic circular icon="facebook" href={featured[key].facebook} size="huge" className="mpost-featured--social" target="_blank" />
                                                    <Button basic circular icon="instagram" href={featured[key].instagram} size="huge" className="mpost-featured--social" target="_blank" />
                                                    <Button basic circular icon="linkify" href={featured[key].web} size="huge" className="mpost-featured--social" target="_blank" />
                                                </p>
                                            </Fade>
                                        </div>
                                    </div>
                                )
                            } else {
                                return (
                                    <div key={uuidv4()} className="mpost-featured--row inverted">
                                        <div className="mpost-featured-image mobile" style={{ backgroundImage: `url(${featured[key].image})` }}>
                                            <Modal closeIcon basic dimmer="blurring" size="fullscreen" trigger={<Button size="massive" fluid inverted basic className="mpost-video--button mobile"><Image centered src={PlayButton} /></Button>}>
                                                <div className='embed-container'><iframe src={featured[key].video} frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe></div>
                                            </Modal>
                                        </div>
                                        <div className="mpost-featured-contents mobile">
                                            <Fade>
                                                <Header as="h1" style={{color:'#FFF'}} textAlign="center" inverted className="mpost-header--big mobile">
                                                    {featured[key].title.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}
                                                </Header>
                                                <Header textAlign="center" as="h3" inverted content={featured[key].sub} className="mpost-subheader--gradient" />
                                                <p className="mpost-p inverted mobile">{featured[key].text}</p>
                                                <p className="mpost-p mobile" style={{textAlign:'center'}}>
                                                    <Button basic circular inverted icon="facebook" href={featured[key].facebook} size="huge" className="mpost-featured--social" target="_blank" />
                                                    <Button basic circular inverted icon="instagram" href={featured[key].instagram} size="huge" className="mpost-featured--social" target="_blank" />
                                                    <Button basic circular inverted icon="linkify" href={featured[key].web} size="huge" className="mpost-featured--social" target="_blank" />
                                                </p>
                                            </Fade>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </Responsive>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Works.js